var React = require('react');

function LogoArrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.6664 4.29075C16.1112 4.70721 16.1112 5.4057 15.6664 5.82216L8 13L0.33361 5.82216C-0.111203 5.4057 -0.111203 4.70721 0.33361 4.29075C0.747657 3.90308 1.39753 3.90308 1.81157 4.29075L8 10.0848L14.1884 4.29075C14.6025 3.90309 15.2523 3.90309 15.6664 4.29075Z","fill":"#E8EFFF"})));
}

LogoArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LogoArrow;

LogoArrow.default = LogoArrow;
